import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=484f7d00&"
import script from "./Legacy.vue?vue&type=script&lang=js&"
export * from "./Legacy.vue?vue&type=script&lang=js&"
import style0 from "./Legacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports